import { createFileRoute } from "@tanstack/react-router";
import { CityServiceCostPage, buildCityServiceCostHead } from "@/components/CityServiceCostPage";

export const Route = createFileRoute("/pueblo-web-design-cost")({
  headers: () => ({
    "Cache-Control": "public, max-age=0, s-maxage=604800, stale-while-revalidate=2592000",
    "CDN-Cache-Control": "public, s-maxage=604800, stale-while-revalidate=2592000",
  }),
  head: () => buildCityServiceCostHead("pueblo", "web-design"),
  component: () => <CityServiceCostPage city="pueblo" service="web-design" />,
});
